import Footer from "../components/footer";
import Header from "../components/header"
import SideNav from "../components/sidenav"
import PageHeader from "../components/pageHeader";
import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";


const Medium = () => {

    // State variables to manage button visibility
    const [showSubmitButton, setShowSubmitButton] = useState(true);
    const [showUpdateButton, setShowUpdateButton] = useState(false);

    const [newdata, setNewdata] = useState({
        id:"", medium: ""
    });
    const { medium } = newdata;

    const [dataMedium, setDataMedium] = useState([]);

    // Function to Fetch data from API for dropdown
    const fetchData = async (url, setData) => {

        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }

    };

    useEffect(() => {
        fetchData('https://igapi.heuristticminds.com/api/SubjectStyleList/Get-GetMediumDetailsAll', setDataMedium);

    }, [dataMedium]);

    

    const columns = [
        
        {            
            name: "Medium / Material",
            selector: row => row.medium,
            sortable: true, 
            width: "300px",           
        },        
        {
            name: "Action",
            cell: (row) => (
                <div>
                    <Link to={``} onClick={() => onStatusClick(row.id)}>
                        <img
                            src={row.status === 1 ? "/images/ImgActive.gif" : "/images/ImgInActive.gif"}
                            alt="Change Status"
                            title="Change Status"
                            style={{ width: "50px", height: "25px" }}
                        />
                    </Link>

                    {' '} {' '}{' '} {' '}{' '} {' '}{' '} {' '}
                    {' '} {' '}{' '} {' '}{' '} {' '}{' '} {' '}
                    <Link to={``} onClick={(event) => onEditClick(row.id)}>
                        <img
                            src="/images/ImgEdit.ico" // Set the correct image source
                            alt="Edit"
                            title="Edit"
                            style={{ width: "30px", height: "30px" }}
                        />
                    </Link>
                </div>
            ),
            maxWidth:"200px",

        },
    ];

    const onStatusClick = async(id)=>{

        const confirmed = window.confirm("Are you sure you want to change Medium / Material status?");
        if (!confirmed) {
            return; // If not confirmed, return early without deleting
        }
        try {
            
            const response = await fetch('https://igapi.heuristticminds.com/api/SubjectStyleList/Update-ChangeMediumStatus?id=' + id, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (response.ok) {
                fetchData('https://igapi.heuristticminds.com/api/SubjectStyleList/Get-GetMediumDetailsAll', setDataMedium);
            }
        }
        catch {
        }
    }

    const onEditClick = async(id)=>{
        
        alert (id);
        const url = 'https://igapi.heuristticminds.com/api/SubjectStyleList/Get-GetMediumDetailsToEditByID?id=' + id;
        const response = await fetch(url);
        if (response.ok) {
            const data = await response.json();
            if (data && data.length > 0) {
                const mediumData = data[0];
                setNewdata({
                    ...newdata, // Preserving other state in case it's needed
                    id: mediumData.id,
                    medium: mediumData.medium
                });
                
            } else {
                console.log("No data received for id:", id);
            }
        } else {
            console.error("Failed to fetch Medium for editing:", response.statusText);
        }
        setShowSubmitButton(false);
        setShowUpdateButton(true);
    };

    const handleMediumChange = (event) => {
        setNewdata({ ...newdata, medium: event.target.value });
    };
    

    const handleUpdate = async()=>{

         const confirmed = window.confirm("Are you sure you want to update medium name ?");
         if (!confirmed) {
             return; // If not confirmed, return early without deleting
         }
        try {
            
            const response = await fetch('https://igapi.heuristticminds.com/api/SubjectStyleList/Update-UpdateMediumDetails?id='+ newdata.id+'&value='+ newdata.value, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (response.ok) {
                setNewdata({ medium: ""});
                fetchData('https://igapi.heuristticminds.com/api/SubjectStyleList/Get-GetMediumDetailsAll', setDataMedium);
            }
        }
        catch {
        }
        setShowSubmitButton(true);
        setShowUpdateButton(false);
    };

    const handleSubmit = async()=> {
        // Check if both title and policyDetails are not empty
        if (medium.trim() === '') {
            alert('Please fill in Medium fields.'); // You can replace this with a more sophisticated validation message
            return; // Prevent form submission if validation fails
        }
        const formData = {

            "medium": medium
        };
        try {
            // Make the API call to save the form data
            const response = await fetch('https://igapi.heuristticminds.com/api/SubjectStyleList/Add-SaveMediumDetailList', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
            if (response.ok) {                
                
                setNewdata({ medium: "" });
                const confirmed = window.confirm("Surface Name Saved Successfully !!!");
                
                

            } else {
                // Handle error cases
                console.error('Error saving form data:', response.statusText);
            }
        } catch (error) {
            console.error('Error saving form data:', error);
        }

    };
    const handleRefresh = async()=> {

        setNewdata({ medium: ""});
        fetchData('https://igapi.heuristticminds.com/api/SubjectStyleList/Get-GetMediumDetailsAll', setDataMedium);

        setShowSubmitButton(true);
        setShowUpdateButton(false);
    }

    return(

        <>
            <Header />
        <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">

                    <PageHeader name='' icon='bi bi-activity' />
                    <div className="container-xl px-4">
                        <div className="row">
                            <div className="col-lg-12 mb-4">
                                <div className="card mb-4 vh-100">
                                    <div className="card-header">Medium / Material Details</div>
                                    <div className="card-body">
                                    
                                    <div className="row">
                                        
                                        <div className="col-sm-2 form-group mb-2">
                                            
                                        </div>
                                        <div className="col-sm-4 form-group mb-2">
                                            <label>Medium / Material <span style={{ color: "#ff0000" }}>*</span></label>
                                        </div>
                                       
                                        
                                        <div className="col-sm-2 form-group mb-2">
                                            
                                        </div>
                                        <div className="col-sm-4 form-group mb-4">
                                        
                                        </div>
                                        
                                               
                                    </div>
                                            
                                    <div className="pb-2">
                                    <div className="row">
                                            
                                            <div className="col-sm-2 form-group mb-2">
                                                
                                            </div>
                                            <div className="col-sm-4 form-group mb-2">
                                                
                                                <input type="text"
                                                    name="medium"
                                                    value={medium}
                                                    className="form-control"
                                                    maxLength={15}
                                                    placeholder="Medium Name"
                                                    onChange={handleMediumChange} 
                                                    />
                                            </div>
                                            
                                            
                                            <div className="col-sm-2 form-group mb-2">
                                                
                                            </div>
                                            <div className="col-sm-4 form-group mb-4">
                                            <button type="button" onClick={handleSubmit} 
                                             className={`btn btn-primary w-50 ${showSubmitButton ? '' : 'd-none'}`}>Submit</button>
                                            <button type="button" onClick={handleUpdate} className={`btn btn-primary w-50 ${showUpdateButton ? '' : 'd-none'}`}>Update</button>                                              
                                            
                                            
                                            <button type="button" onClick={handleRefresh} 
                                             className={`btn btn-primary w-50`}>Refresh</button>
                                             </div>
                                            </div>
                                            
                                    </div>
                                    <div className="ps-2 pe-2">
                                    <DataTable 
                                                    columns={columns}
                                                    data={dataMedium}
                                                    pagination
                                                /> 
                                    </div>
   
                                    </div>
                                    </div>
                                    
                                    
                                    
                                
                            </div>

                        </div>
                    </div>
                    </div>
                    <Footer />
                </div>
            
        </>
        
    )
};
export default Medium;